import { ChosenAnswer, Result, ResultMap } from "@abbvie-epi/common/models/";
import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { catchError, firstValueFrom, map, Observable, of } from "rxjs";
import * as publicationConfig from "./../configs/publications.config";
import * as summariesConfig from "./../configs/summaries.config";

@Injectable({
    providedIn: "root"
})
export class ResultsService {
    private resultConfig: ResultMap | undefined;

    public chosenAnswers: ChosenAnswer[] = [];

    constructor(private http: HttpClient) {
        this.http = http;
    }

    private getResultConfig(): Observable<ResultMap | undefined> {
        if (this.resultConfig) {
            return of(this.resultConfig);
        }

        return this.http.get("assets/config/results-config.json").pipe(
            map((res: any) => {
                return res as ResultMap;
            }),
            catchError((e) => {
                console.log(e);
                return of(undefined);
            })
        );
    }

    public setResultId(resultId: string): void {
        if (resultId) {
            sessionStorage.setItem("resultId", resultId);
        }
    }

    public getResultId(): string {
        const resultId = sessionStorage.getItem("resultId");

        if (resultId) {
            return resultId;
        }
        return "";
    }

    public async getResult(): Promise<Result | undefined> {
        const resultConfig = await firstValueFrom(this.getResultConfig());
        const resultId = sessionStorage.getItem("resultId");

        if (resultConfig && resultId) {
            const resultIds = Object.keys(resultConfig);

            if (resultIds.includes(resultId)) {
                // Get publications from the config
                this.getSummariesAndPublications(resultConfig[resultId]);

                return resultConfig[resultId];
            }
        }
        return undefined;
    }

    public getResultStatus() {
        if (sessionStorage.getItem("resultId")) {
            return true;
        }
        return false;
    }

    // Clear results from storage to restart screening
    public clearResult() {
        sessionStorage.removeItem("resultId");
    }

    private getSummariesAndPublications(result: Result) {
        result.publications.forEach((publication, index) => {
            result.publications[index] = publicationConfig.allPublications[publication];
        });
        result.summary.forEach((summary, index) => {
            result.summary[index] = summariesConfig.allSummaries[summary];
        });
    }
}
